/** Default progressive transaction fees (aligned with company registration copy). */
export interface TransactionTariffTier {
  range: string;
  rate: string;
}

export const TRANSACTION_TARIFF_TIERS: TransactionTariffTier[] = [
  { range: 'da 1 a 150 iscrizioni anno', rate: '2,2 % del transato' },
  { range: 'da 151 a 280 iscrizioni anno', rate: '2,0 % del transato' },
  { range: 'da 281 a 480 iscrizioni anno', rate: '1,8 % del transato' },
  { range: 'Iscrizioni illimitate', rate: '1,6 % del transato' }
];
